<template>
  <div class="f-col gap-4 between md:flex-row">
    <div class="flex center gap-4 between">
      <span>{{ $t.loyaltyProgram }}</span>
      <vf-switch v-model="activeCommunity" />
    </div>
    <div class="w-full md:w-80">
      <vf-select v-model="activeLocation" :options="locationOptions" :placeholder="$t.allLocations">
        <span>{{ $t.filterLocation }}:</span>
      </vf-select>
    </div>
  </div>
  <base-grid class="my-4" :cols="{ sm: 1, md: 2 }" gap-x="sm" gap-y="lg">
    <transition-group name="slide">
      <template
        v-for="({ id,
                  title,
                  titleHtml,
                  image,
                  bodyCopy,
                  locations,
                  locationName,
                  date,
                  mediaList,
                  latitude,
                  longitude,
                  bookingUrl,
                  rightCopy,
                  leftCopy,
                  ecode,
                  cvent,
                  communityEvent,
        }) in filteredEvents"
        :key="id"
      >
        <article class="f-col gap-2 md:flex-row">
          <base-picture v-bind="image" class="flex-1" fit="contain" />
          <div class="f-col flex-1 gap-2 between">
            <div class="b-brand-1/20 space-y-2 <md:b-b <md:pb-2">
              <h2 class="title-2">
                <span v-if="$feature.showTitleHtml" v-html="titleHtml" />
                <template v-else>
                  {{ title }}
                </template>
              </h2>
              <span v-if="communityEvent" class="bg-brand-5 p-1 text-xs">{{ $t.loyaltyProgram }}</span>
              <cms-rich-text :content="{ richText: bodyCopy }" />
            </div>
            <div class="grid gap-2 md:cols-2">
              <div class="flex gap-2 text-sm md:f-col">
                <div v-if="locations || locationName" class="flex items-center gap-2 <md:w-1/2">
                  <vf-icon name="location" size="md" />
                  <div>
                    <p v-if="locationName">
                      {{ locationName }}
                    </p>
                    <p v-if="locations">
                      {{ locations.map(({ name }) => name).join(" - ") }}
                    </p>
                  </div>
                </div>
                <div v-if="date" class="flex items-center gap-2 uppercase <md:w-1/2">
                  <vf-icon name="calendar" size="md" />
                  <div class="f-col">
                    <time :datetime="date.start">{{ date.start }}</time>
                    <time v-if="date.end && date.start !== date.end" :datetime="date.end">
                      {{ date.end }}
                    </time>
                    <span>
                      <time :datetime="date.startTime">{{ date.startTime }}</time>
                      <time v-if="date.endTime && date.startTime !== date.endTime" :datetime="date.endTime">
                        {{ ` -` }} {{ date.endTime }}
                      </time>
                    </span>
                  </div>
                </div>
              </div>
              <vf-button
                class="self-end <md:w-full"
                size="xs"
                variant="secondary"
                @click="activeEvent = id !== activeEvent ? id : null"
              >
                {{ activeEvent === id ? $t.close : $t.viewEvent }}
                <vf-icon :dir="activeEvent === id ? 'up' : 'down'" name="arrow" />
              </vf-button>
            </div>
          </div>
        </article>
        <div
          v-show="activeEvent === id"
          class="b-brand-1/20 md:col-span-2 <md:b-y <md:py-3"
        >
          <div class="flex flex-row-reverse pb-2">
            <base-button @click="activeEvent = null">
              <vf-icon name="close" size="md" />
            </base-button>
          </div>
          <div class="f-col gap-3 md:flex-row">
            <base-picture v-bind="mediaList[0]" class="flex-1" fit="contain" />
            <div class="f-col flex-1 between space-y-2">
              <div class="space-y-2">
                <h2 class="title-1">
                  <span v-if="$feature.showTitleHtml" v-html="titleHtml" />
                  <template v-else>
                    {{ title }}
                  </template>
                </h2>
                <div class="flex gap-2 md:gap-6">
                  <div v-if="locations || locationName" class="flex items-center gap-2 <md:w-1/2">
                    <vf-icon name="location" size="md" />
                    <div class="text-base">
                      <p v-if="locationName">
                        {{ locationName }}
                      </p>
                      <p v-if="locations">
                        {{ locations.map(({ name }) => name).join(" - ") }}
                      </p>
                    </div>
                  </div>
                  <div v-if="date" class="flex items-center gap-2 uppercase <md:w-1/2">
                    <vf-icon name="calendar" size="md" />
                    <div class="f-col">
                      <time :datetime="date.start">{{ date.start }}</time>
                      <time v-if="date.end && date.start !== date.end" :datetime="date.end">
                        {{ date.end }}
                      </time>
                      <span>
                        <time :datetime="date.startTime">{{ date.startTime }}</time>
                        <time v-if="date.endTime && date.startTime !== date.endTime" :datetime="date.endTime">
                          {{ ` -` }} {{ date.endTime }}
                        </time>
                      </span>
                    </div>
                  </div>
                </div>
                <cms-rich-text class="text-sm" :content="{ richText: leftCopy }" />
              </div>
              <div class="f-col gap-2">
                <p v-if="communityEvent" class="text-sm">
                  {{ $t.event.reservedForMembers }}
                </p>
                <template v-if="bookingUrl || cvent">
                  <div
                    v-if="($feature.enableLoyaltyFeatures && communityEvent && !user.isLoyaltyMember)
                      || (cvent && !auth.loggedIn)"
                    class="flex gap-2"
                  >
                    <vf-button
                      class="w-1/2"
                      size="xs"
                      @click="handleSignIn"
                    >
                      {{ $t.event.alreadyMember }}
                    </vf-button>
                    <vf-button
                      v-if="!auth.loggedIn"
                      class="w-1/2"
                      size="xs"
                      variant="secondary"
                      @click="DialogSignUp.open({ formLocation: 'modal:single:pop-up:none' })"
                    >
                      {{ $t.event.registerCommunity }}
                    </vf-button>
                  </div>
                  <template
                    v-else-if="cvent && user.profile
                      && CEventSignature?.secureSignature && CEventSignature?.timestamp"
                  >
                    <form :action="$feature.configCeventDomain" method="POST" target="_blank">
                      <input name="ecode" type="hidden" :value="ecode">
                      <input name="first_name" type="hidden" :value="user.profile.consumerDetails.firstName">
                      <input name="last_name" type="hidden" :value="user.profile.consumerDetails.lastName">
                      <input name="email_address" type="hidden" :value="user.profile.consumerDetails.email">
                      <input name="source_id" type="hidden" :value="user.profile.consumerDetails.consumerId">
                      <input name="target" type="hidden" value="Registration">
                      <input name="reg_signature" type="hidden" :value="CEventSignature.secureSignature">
                      <input name="timestamp" type="hidden" :value="CEventSignature.timestamp">
                      <vf-button class="w-full" size="xs" type="submit">
                        {{ $t.event.reserveSpot }}
                      </vf-button>
                    </form>
                  </template>
                  <template v-else>
                    <vf-button class="w-full" size="xs" :to="bookingUrl">
                      {{ $t.event.reserveSpot }}
                    </vf-button>
                  </template>
                  <vf-button
                    v-if="latitude && longitude"
                    class="w-full"
                    size="xs"
                    variant="secondary"
                    @click="openMap(latitude, longitude)"
                  >
                    <vf-icon name="location" size="md" />
                    {{ $t.event.howtogetthere }}
                  </vf-button>
                </template>
              </div>
            </div>
            <div v-if="rightCopy" class="relative flex-1">
              <div v-style:max-h="{ sm: '18rem', md: 'auto' }" class="overflow-x-auto md:absolute-0">
                <cms-rich-text :content="{ richText: rightCopy }" />
              </div>
            </div>
          </div>
          <div v-if="latitude && longitude" class="mt-3 f-col gap-2 md:flex-row">
            <base-google-map
              class="w-full"
              :class="{ 'md:w-2/3': mediaList[1] }"
              :locations="[{ lat: latitude, lng: longitude, title: '', id: '' }]"
              :options="{ disableDefaultUI: true }"
              style="min-height: 14.5rem;"
            />
            <base-picture v-if="mediaList[1]" v-bind="mediaList[1]" class="flex-1" fit="contain" />
          </div>
        </div>
      </template>
    </transition-group>
  </base-grid>
</template>

<script lang="ts" setup>
import type { CEventResponse } from '#types/cevent'
import type { EventCollectionContent } from '#types/components/cms/event-collection'

const { content } = defineProps<{ content: EventCollectionContent }>()

const { $locale } = useNuxtApp()
const { DialogLoyaltySignUp, DialogSignIn, DialogSignUp } = useDialogsStore()
const user = useUserStore()
const auth = useAuthStore()
const { isDev } = useRuntimeConfig().public

const activeLocation = ref('')
const activeCommunity = ref(false)
const activeEvent = ref()
const CEventSignature = ref<CEventResponse>()

const formatTime = (timeStr: string) => {
  const [hour, minute] = timeStr.split(':').map(Number)
  const date = new Date()
  date.setHours(hour, minute)
  return date.toLocaleTimeString($locale, { hour: 'numeric', minute: '2-digit', hour12: true })
}

const handleSignIn = () => !auth.loggedIn
  ? DialogSignIn.open({ formLocation: 'modal:single:pop-up:none' })
  : DialogLoyaltySignUp.open({ formLocation: 'modal:single:pop-up:none' })

const events = computed(() => content.items.map((item) => ({
  ...item as any,
  date: {
    start: getFormattedDate(item.startDate),
    ...(item.endDate && { end: getFormattedDate(item.endDate) }),
    ...(item.startTime && { startTime: formatTime(item.startTime) }),
    ...(item.endTime && { endTime: formatTime(item.endTime) })
  },
  image: { ...item.image, src: item.image.url },
  mediaList: item.mediaList.map((image) => {
    const { url: src, alt, ...rest } = swapObjectKeys(image)
    return { ...rest, src, alt: getValueForBreakpoint('sm', alt) }
  }),
})))

const filteredEvents = computed(() =>
  events.value.filter(({ locations, communityEvent }) => (!activeLocation.value || locations
    ?.some(({ name }) => name === activeLocation.value))
  && (!activeCommunity.value || communityEvent)
  )
)

const locationOptions = computed(() =>
  [...new Set(events.value.flatMap(({ locations }) => locations?.map(({ name }) => name)))])

if (!isDev) {
  watchImmediate([() => user.profile?.consumerDetails?.email, activeEvent], async ([email, event]) => {
    if (email && event) {
      try {
        CEventSignature.value = await $fetch<CEventResponse>('/edge/get-cevent-secure-signature', {
          method: 'POST',
          body: { email }
        })
      }
      catch (err) {
        log.info(err)
      }
    }
  })
}

watch([activeLocation, activeCommunity], () => {
  activeEvent.value = null
})

const openMap = (lat: number, lng: number) => {
  window.open(`https://www.google.com/maps?q=${lat},${lng}`, '_blank', 'noopener,noreferrer')
}
</script>
